export enum BubbleHintArrowPosition {
  UP = 'bubble-hint--arrow-position-up',
  DOWN = 'bubble-hint--arrow-position-down',
}
